import * as React from 'react';

import { clientAppSettings } from "../Models/ClientAppSettings";
import { UserAgreementConsentInfo } from '../Generated/RestClient';
import { resourceStrings } from '../../../Intercom.ReactUI/Views/Strings';

export interface UserAgreementConsentFormFieldsProps {
    showLuisTerms?: boolean;
    onAgreeToTermsChanged?: (boolean) => any;
}

export interface UserAgreementConsentFormFieldsState {
    botFrameworkTermsAgreed: boolean;
    luisTermsAgreed: boolean;

    botFrameworkAgreementLabelContent: { __html: string };
    luisAgreementLabelContent: { __html: string };
}

export class UserAgreementConsentFormFields extends React.Component<UserAgreementConsentFormFieldsProps, UserAgreementConsentFormFieldsState> {
    constructor(props?: UserAgreementConsentFormFieldsProps, context?: any) {
        super(props, context);

        const strs = resourceStrings.subscriptionConsentDialog;

        this.state = {
            botFrameworkTermsAgreed: false,
            luisTermsAgreed: false,

            botFrameworkAgreementLabelContent: { __html: strs.agreementLabelHtml },
            luisAgreementLabelContent: { __html: strs.luisAgreementLabelHtml }
        };
    }

    public static defaultProps: Partial<UserAgreementConsentFormFieldsProps> = {
        showLuisTerms: false
    }

    private mutateState(mutator: (UserAgreementConsentFormFieldsState) => void) {
        this.setState(state => {
            const mutatedState = _.extend({}, state) as UserAgreementConsentFormFieldsState;

            mutator(mutatedState);

            return mutatedState;
        }, () => this.props.onAgreeToTermsChanged && this.props.onAgreeToTermsChanged(this.state.botFrameworkTermsAgreed && (!this.props.showLuisTerms || this.state.luisTermsAgreed)));
    }

    private onAgreeToBotFrameworkTerms = (e: React.FormEvent<HTMLInputElement>) => {
        const target = e.target as HTMLInputElement;

        this.mutateState(state => state.botFrameworkTermsAgreed = target.checked);
    }

    private onAgreeToLuisTerms = (e: React.FormEvent<HTMLInputElement>) => {
        let t = e.target as HTMLInputElement;

        this.mutateState(state => state.luisTermsAgreed = t.checked);
    }

    public render() {
        return (
            <div className="user-agreement-consent-form">
                <label className="checkbox-row">
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            value="agreed"
                            checked={this.state.botFrameworkTermsAgreed}
                            onChange={this.onAgreeToBotFrameworkTerms}
                        />
                    </div>

                    <div className="checkbox-row">
                        <span className="checkbox-label" dangerouslySetInnerHTML={this.state.botFrameworkAgreementLabelContent} />
                    </div>
                </label>
                {
                    !!this.props.showLuisTerms &&
                        <label className="checkbox-row">
                            <div className="checkbox-container">
                                <input
                                    type="checkbox"
                                    value="agreed"
                                    checked={this.state.luisTermsAgreed}
                                    onChange={this.onAgreeToLuisTerms}
                                />
                            </div>

                            <div className="checkbox-row">
                                <span className="checkbox-label" dangerouslySetInnerHTML={this.state.luisAgreementLabelContent} />
                            </div>
                        </label>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Client/Views/UserAgreementConsentFormFields.tsx